import { render, staticRenderFns } from "./SettingsContentSections.vue?vue&type=template&id=3e7fe057&lang=pug&"
import script from "./SettingsContentSections.vue?vue&type=script&lang=js&"
export * from "./SettingsContentSections.vue?vue&type=script&lang=js&"
import style0 from "./SettingsContentSections.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports